import { apiRequest } from '../http.js'

export const invoicesApi = {
getPresignedUpload: async ({ campaignId, filename, contentType }) => {
      const qs = new URLSearchParams({
        campaignId,
        filename,
        ...(contentType ? { contentType } : {}),
      })
      return apiRequest(`/invoices/presigned-upload?${qs.toString()}`)
    },

    
    create: async (body) => {
      return apiRequest('/invoices', {
        method: 'POST',
        body: JSON.stringify(body),
      })
    },

    
    uploadLocal: async (formData) => {
      return apiRequest('/invoices/upload', {
        method: 'POST',
        body: formData,
      })
    },

    
    getPendingReview: async () => {
      const data = await apiRequest('/invoices/pending-review')
      return data.invoices || []
    },

    
    markReviewed: async (invoiceId) => {
      return apiRequest(`/invoices/${invoiceId}/review`, { method: 'POST' })
    },
}
